import { render } from "./CreateDeliveries.vue?vue&type=template&id=370ce898"
import script from "./CreateDeliveries.vue?vue&type=script&lang=js"
export * from "./CreateDeliveries.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__